function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M8 5.5a.5.5 0 01.5.5v5a.5.5 0 01-1 0V6a.5.5 0 01.5-.5z",
  clipRule: "evenodd"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M7.646 4.646a.5.5 0 01.708 0l3 3a.5.5 0 01-.708.708L8 5.707 5.354 8.354a.5.5 0 11-.708-.708l3-3z",
  clipRule: "evenodd"
});

function SvgArrowUp(props) {
  return React.createElement("svg", _extends({
    className: "arrow-up_svg__bi arrow-up_svg__bi-arrow-up-short",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyBjbGFzcz0iYmkgYmktYXJyb3ctdXAtc2hvcnQiIHdpZHRoPSIxZW0iIGhlaWdodD0iMWVtIiB2aWV3Qm94PSIwIDAgMTYgMTYiIGZpbGw9ImN1cnJlbnRDb2xvciIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04IDUuNWEuNS41IDAgMDEuNS41djVhLjUuNSAwIDAxLTEgMFY2YS41LjUgMCAwMS41LS41eiIgY2xpcC1ydWxlPSJldmVub2RkIi8+CiAgPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNNy42NDYgNC42NDZhLjUuNSAwIDAxLjcwOCAwbDMgM2EuNS41IDAgMDEtLjcwOC43MDhMOCA1LjcwNyA1LjM1NCA4LjM1NGEuNS41IDAgMTEtLjcwOC0uNzA4bDMtM3oiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPgo8L3N2Zz4=";
export { SvgArrowUp as ReactComponent };